export default __webpack_public_path__ + "static/stats-headspace_17-19570c013fe46e9c111a1490bce988a4.png";